import React from "react";
import viewUserStyles from "./styles/viewUser.module.css";
import individualViewStyles from "./styles/individual-view.module.css";
import { loadColorCode, getSpo2Value } from "../../utils/change-spo2-color";
import {
  getAirQualityStatus,
  getAirQualityStatusColor,
} from "../../utils/air-quality";

/** Show body temperature in °F; values below 60 are treated as Celsius. */
function formatBodyTemperatureFahrenheit(raw) {
  if (raw === undefined || raw === null || raw === "") return undefined;
  const n =
    typeof raw === "number" ? raw : parseFloat(String(raw).replace(/,/g, ""));
  if (Number.isNaN(n)) return String(raw);
  const fahrenheit = n < 60 ? (n * 9) / 5 + 32 : n;
  const rounded = Math.round(fahrenheit * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function SingleVital({
  fData,
  item,
  Icon,
  title,
  subTitle,
  field,
  variant = "default", // "default" -> view user styles, "individual" -> individual-view styles
}) {
  const styles =
    variant === "individual" ? individualViewStyles : viewUserStyles;
  const userId = String(item?.user_id ?? "");
  const series = fData && userId && Array.isArray(fData[userId]) ? fData[userId] : [];
  const lastReading = series.length ? series[series.length - 1] : null;
  const value =
    lastReading && field in lastReading ? lastReading[field] : undefined;
  const isAirQuality = field === "air_quality";
  const isBodyTemperature = field === "body_temperature";
  const hasValue = value !== undefined && value !== null && value !== "";
  const displayValue =
    isBodyTemperature && hasValue
      ? formatBodyTemperatureFahrenheit(value)
      : value;
  const showBodyTemp = isBodyTemperature && hasValue;
  const airQualityStatus =
    isAirQuality && hasValue ? getAirQualityStatus(value) : "";
  const airQualityColor =
    isAirQuality && hasValue ? getAirQualityStatusColor(value) : undefined;

  return (
    <div className={styles.box2}>
      <p className={styles.divText}>{title}</p>
      <div className={styles.box3}>
        <Icon
          className={styles.vitalIcon}
          style={{ width: "1.67rem", height: "1.31rem" }}
        />

        {title === "Oxygen" ? (
          <p
            className={styles.number}
            style={loadColorCode(getSpo2Value(fData, item))}
          >
            {getSpo2Value(fData, item).value}
          </p>
        ) : (
          <p className={styles.number2}>
            {showBodyTemp
              ? displayValue
              : hasValue
                ? value
                : "--"}
          </p>
        )}

        <p
          className={styles.divText}
          style={{
            // marginLeft: "0.15rem",
            ...(isAirQuality && hasValue && airQualityColor
              ? { color: airQualityColor }
              : {}),
          }}
        >
          {isAirQuality
            ? hasValue && airQualityStatus
              ? airQualityStatus.toLowerCase()
              : ""
            : subTitle}
        </p>
      </div>
    </div>
  );
}
